// extracted by mini-css-extract-plugin
export default {"navigation__logo":"NavigationLogo_navigation__logo__aym+S","logo-box":"NavigationLogo_logo-box__xiPs2"};